import { stringLiteral } from '@execonline-inc/decoders';
import { Decoder, array, boolean, field, number, string, succeed } from 'jsonous';
import { resourceDecoder } from '../../Resource/Decoders';
import {
  Dashboard,
  DashboardType,
  DashboardResource,
  ReportResource,
  ReportWithDashboards,
} from '../Types';

const dashboardTypeDecoder: Decoder<DashboardType> = stringLiteral<DashboardType>('quicksight');

const dashboardDecoder: Decoder<Dashboard> = succeed({})
  .assign('id', field('id', number))
  .assign('name', field('name', string))
  .assign('dashboardType', field('dashboard_type', dashboardTypeDecoder))
  .assign('dashboardUri', field('dashboard_uri', string))
  .assign('height', field('height', number))
  .assign('width', field('width', number));

const dashboardResourceDecoder: Decoder<DashboardResource> = resourceDecoder(dashboardDecoder);

const reportWithDashboardDecoder: Decoder<ReportWithDashboards> = succeed({})
  .assign('id', field('id', number))
  .assign('name', field('name', string))
  .assign('beta', field('beta', boolean))
  .assign('dashboards', field('dashboards', array(dashboardResourceDecoder)));

export const reportResourceDecoder: Decoder<ReportResource> = resourceDecoder(
  reportWithDashboardDecoder,
);
